import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'my-bill-odb-section-variant-two',
  templateUrl: './odb-section-variant-two.component.html',
  standalone: false,
})
export class OdbSectionVariantTwoComponent {
  @Input() label?: string;
  @Input() amount?: string;
  @Input() linkZone: string;
  @Input() isClickable = true;
  @Output() sectionClick = new EventEmitter<void>();
}
